var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showCustomDialog
    ? _c("div", { staticClass: "custom-dialog-container" }, [
        _c("div", { staticClass: "custom-dialog-background" }),
        _c(
          "div",
          {
            staticClass: "custom-dialog-content",
            style: _vm.customDialogData.styles,
          },
          [
            _c(_vm.customDialogData.name, {
              tag: "component",
              attrs: { componentProps: _vm.customDialogData.props },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }